import React, { useEffect } from 'react'
import Additional from './Additional'
import Comment from './Comment'

const Netwrok = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);
  return (
    <div>
   <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-8">
        {/* Course Detail Start */}
        <div className="mb-5">
          <h1 className="mb-4">Hardware and Networking Essentials</h1>
          <p>Gain a comprehensive understanding of hardware and networking fundamentals, essential for building and maintaining modern computer systems and networks. This course covers the basics of hardware components, network architecture, and practical skills to set up and troubleshoot networks. Our expert instructors guide you through hands-on exercises and real-world scenarios to prepare you for a successful career in IT infrastructure.</p>
          
          {/* Course Outline */}
          <b>Session 1: Introduction to Computer Hardware</b>
          <p>Overview of computer hardware components, CPU, RAM, storage devices</p>
          
          <b>Session 2: Operating Systems and Software</b>
          <p>Understanding operating systems, software installation, updates</p>
          
          <b>Session 3: Network Fundamentals</b>
          <p>Introduction to networking, OSI model, TCP/IP protocols</p>
          
          <b>Session 4: Network Devices and Topologies</b>
          <p>Routers, switches, hubs, network topologies, LAN vs. WAN</p>
          
          <b>Session 5: IP Addressing and Subnetting</b>
          <p>IPv4, IPv6, subnetting, IP addressing schemes</p>
          
          <b>Session 6: Network Configuration and Troubleshooting</b>
          <p>Setting up networks, DHCP, DNS, common network issues</p>
          
          <b>Session 7: Wireless Networking</b>
          <p>Wi-Fi standards, configuring wireless networks, security</p>
          
          <b>Session 8: Network Security</b>
          <p>Firewalls, encryption, security best practices</p>
          
          <b>Session 9: Virtualization and Cloud Computing</b>
          <p>Introduction to virtualization, cloud services, benefits</p>
          
          <b>Session 10: Network Monitoring and Management</b>
          <p>Monitoring tools, network management practices</p>
          
          <b>Session 11: Network Troubleshooting</b>
          <p>Diagnosing and resolving network issues, troubleshooting techniques</p>
          
          <b>Session 12: Cybersecurity Basics</b>
          <p>Understanding cybersecurity threats, malware, phishing</p>
          
          <b>Session 13: Introduction to Servers</b>
          <p>Server types, roles, server operating systems</p>
          
          <b>Session 14: Data Backup and Recovery</b>
          <p>Backup strategies, disaster recovery planning</p>
          
          <b>Session 15: Final Project</b>
          <p>Design and implement a network infrastructure</p>
        </div>
        {/* Course Detail End */}
        {/* Comment List Start */}
        <Comment />
        {/* Comment Form End */}
      </div>
      {/* Sidebar Start */}
      <div className="col-lg-4">
        {/* Search Form Start */}
        <Additional />
        {/* Plain Text End */}
      </div>
      {/* Sidebar End */}
    </div>
  </div>
</div>

    </div>
  )
}

export default Netwrok